module.exports = __webpack_public_path__ + "static/media/star.1f23f6d5.svg";